// extracted by mini-css-extract-plugin
export default {"root":"searchCard_root__-2BxZ","img_wrap":"searchCard_img_wrap__Cp8Pl","img":"searchCard_img__9Ar-0","content":"searchCard_content__2b3I+","id_wrap":"searchCard_id_wrap__JGXfT"};